module.exports = __webpack_public_path__ + "static/img/zhuzhai2.60f78529.png";